"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const DateUtilities_1 = require("../DateUtilities");
/**
 * Sorts displayable products by display priority
 * @param products is an array of displayable loans or credit cards
 * @returns a sorted list of displayable products. First they are filtered by isActive, then newest to oldest.
 */
exports.sortedDisplayableProducts = (products) => (exports.destructure(products)
    .filter(product => product.isActive)
    .sort((lhs, rhs) => DateUtilities_1.compareDescending(lhs.createdAt, rhs.createdAt)));
/**
 * Representation of possible product statuses, i.e. `loan.status`.
 */
var ProductStatuses;
(function (ProductStatuses) {
    ProductStatuses["Current"] = "current";
    ProductStatuses["Late"] = "late";
    ProductStatuses["PaidOff"] = "paid_off";
    ProductStatuses["ChargedOff"] = "charged_off";
    ProductStatuses["Applied"] = "applied";
    ProductStatuses["Approved"] = "approved";
    ProductStatuses["Cancelled"] = "cancelled";
    ProductStatuses["Authorization"] = "authorized";
    ProductStatuses["InDefault"] = "in_default";
    ProductStatuses["Transferred"] = "transferred";
})(ProductStatuses = exports.ProductStatuses || (exports.ProductStatuses = {}));
/**
 * Strips away the edge structure and returns an array of nodes
 * @param products is a list of products in edge/nodes format
 * @returns those products, taken from the edge/nodes format and placed in an array
 */
exports.destructure = (products) => products.edges
    .map(edge => edge.node);
